const UseFormHookUtils = require('./hooks');
const UseFormLifecycleUtils = require('./lifecycle');

module.exports = function useManagedFormStateWithLocation({
    formConfig,
    props,
    fields = formConfig?.formFields,
    schema = props?.schema,
    title,
    formId,
    debug,
    defaultsDeps,
    initialStateDeps,
    syncDefaults = false,
    buildInitialState = (_props) => UseFormLifecycleUtils.buildInitialStateWithLocationState({
        initialState: formConfig?.buildInitialManagedState?.(_props),
        locationState: _props.location?.state
    }),
    buildLocationStateActions = UseFormLifecycleUtils.buildLocationStateActions,
    shouldSyncStateDefaults = formConfig?.shouldSyncStateDefaults,
    shouldSyncStateDefaultsAfterPropsChange = formConfig?.shouldSyncStateDefaultsAfterPropsChange
}) {

    return UseFormHookUtils.useManagedFormState({
        formConfig,
        props,
        fields,
        schema,
        title,
        formId,
        debug,
        defaultsDeps,
        initialStateDeps,
        buildInitialState,
        buildLocationStateActions,
        shouldSyncStateDefaults,
        shouldSyncStateDefaultsAfterPropsChange,
        syncDefaults
    });
};
